import React from 'react';

import * as S from './ToggleLogotype.styles';

export interface ToggleLogotypeProps {
  isExpanded?: boolean;
}

export const ToggleLogotype = ({
  isExpanded = false,
  ...rest
}: ToggleLogotypeProps) => {
  return (
    <S.ToggleLogotypeRoot isExpanded={isExpanded} {...rest}>
      <svg
        width="135"
        height="20"
        viewBox="0 0 135 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.84066 4.26993H14.0008V1.6H0.800781V4.26993H5.96091V18H8.84066V4.26993Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M107.685 1.8H96.001V18.4H107.801V15.7675H98.7509V11.3357H106.672V8.70325H98.7509V4.43248H107.685V1.8Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M81.6006 18.4H93.0006V15.7675H84.4418V1.8H81.6006V18.4Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M78.4004 15.8407V8.94027H75.6793V14.5404C75.1895 14.9188 74.6113 15.2215 73.9514 15.4554C73.2847 15.6825 72.5773 15.7926 71.8086 15.7926C70.9854 15.7926 70.2439 15.6412 69.5773 15.3454C68.9106 15.0495 68.3392 14.6299 67.863 14.107C67.38 13.5841 67.0126 12.9581 66.7541 12.2357C66.4956 11.5133 66.3664 10.729 66.3664 9.8828C66.3664 9.08474 66.5024 8.32796 66.7677 7.62622C67.033 6.9176 67.4004 6.29842 67.863 5.76868C68.3256 5.23893 68.8766 4.81238 69.5092 4.50967C70.1419 4.20696 70.8222 4.04873 71.5569 4.04873C72.0603 4.04873 72.5228 4.09 72.9378 4.17944C73.3596 4.262 73.7405 4.38584 74.0943 4.53031C74.448 4.68167 74.7813 4.86054 75.1011 5.0807C75.4208 5.30085 75.7337 5.54164 76.0398 5.80996L77.8222 3.62906C77.4072 3.27131 76.9854 2.95484 76.55 2.67964C76.1147 2.40445 75.6521 2.17742 75.1691 1.98478C74.6793 1.79903 74.1487 1.65455 73.5773 1.55136C73.0058 1.44816 72.3664 1.4 71.6657 1.4C70.4616 1.4 69.3528 1.62703 68.3324 2.0811C67.3188 2.53517 66.448 3.14747 65.7133 3.92489C64.9786 4.70231 64.414 5.60356 64.0058 6.63553C63.6045 7.6675 63.4004 8.76139 63.4004 9.92408C63.4004 11.0868 63.5977 12.2495 63.999 13.2814C64.3936 14.3134 64.9582 15.2078 65.6793 15.9714C66.4072 16.7282 67.2779 17.3268 68.2983 17.7533C69.3188 18.1867 70.4548 18.4 71.7065 18.4C72.4072 18.4 73.0807 18.3312 73.7201 18.2005C74.3596 18.0698 74.9582 17.884 75.516 17.6501C76.0739 17.4162 76.5909 17.141 77.0739 16.8314C77.5569 16.5149 77.9922 16.1916 78.3868 15.8476"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M60.201 15.8407V8.94027H57.4424V14.5404C56.9458 14.9188 56.3665 15.2215 55.6906 15.4554C55.0148 15.6825 54.2975 15.7926 53.5182 15.7926C52.6837 15.7926 51.932 15.6412 51.2561 15.3454C50.5803 15.0495 50.001 14.6299 49.5182 14.107C49.0286 13.5841 48.6561 12.9581 48.3941 12.2357C48.132 11.5133 48.001 10.729 48.001 9.8828C48.001 9.08474 48.1389 8.32796 48.4079 7.62622C48.6768 6.9176 49.0493 6.29842 49.5182 5.76868C49.9872 5.23893 50.5458 4.81238 51.1872 4.50967C51.8286 4.20696 52.5182 4.04873 53.263 4.04873C53.7734 4.04873 54.2424 4.09 54.6699 4.17944C55.0975 4.262 55.4837 4.38584 55.8424 4.53031C56.201 4.68167 56.5389 4.86054 56.863 5.0807C57.1872 5.30085 57.5044 5.54164 57.8148 5.80996L59.6217 3.62906C59.201 3.27131 58.7734 2.95484 58.332 2.67964C57.8906 2.40445 57.4217 2.17742 56.9251 1.98478C56.4286 1.79903 55.8906 1.65455 55.3113 1.55136C54.732 1.44816 54.0837 1.4 53.3734 1.4C52.1527 1.4 51.0286 1.62703 50.001 2.0811C48.9734 2.53517 48.0837 3.14747 47.3458 3.92489C46.601 4.70231 46.0286 5.60356 45.6148 6.63553C45.2079 7.6675 45.001 8.76139 45.001 9.92408C45.001 11.0868 45.201 12.2495 45.601 13.2814C46.001 14.3134 46.5734 15.2078 47.3044 15.9714C48.0355 16.7282 48.9251 17.3268 49.9596 17.7533C50.9941 18.1867 52.1458 18.4 53.4148 18.4C54.1251 18.4 54.8079 18.3312 55.4562 18.2005C56.1044 18.0698 56.7113 17.884 57.2768 17.6501C57.8424 17.4162 58.3665 17.141 58.8562 16.8314C59.3458 16.5149 59.7872 16.1916 60.1872 15.8476"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M34.401 4.28664C37.5422 4.28664 40.1085 6.85765 40.1085 10C40.1085 13.1423 37.5422 15.7134 34.401 15.7134C31.2597 15.7134 28.6935 13.1423 28.6935 10C28.6935 6.85765 31.2597 4.28664 34.401 4.28664ZM34.401 1.6C29.7803 1.6 26.001 5.3817 26.001 10C26.001 14.6183 29.7803 18.4 34.401 18.4C39.0217 18.4 42.801 14.6183 42.801 10C42.801 5.3817 39.0217 1.6 34.401 1.6Z"
          fill="white"
          className="core"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.2012 1C19.2306 1 15.2012 5.02944 15.2012 10C15.2012 14.9706 19.2306 19 24.2012 19H34.6012C39.5717 19 43.6012 14.9706 43.6012 10C43.6012 5.02944 39.5717 1 34.6012 1H24.2012ZM34.4012 18.4C39.0404 18.4 42.8012 14.6392 42.8012 10C42.8012 5.36081 39.0404 1.6 34.4012 1.6C29.762 1.6 26.0012 5.36081 26.0012 10C26.0012 14.6392 29.762 18.4 34.4012 18.4Z"
          className="primary core"
        />
        <circle
          cx="34.4006"
          cy="10"
          r="5.7"
          stroke="#707070"
          strokeWidth="0.2"
          className="core"
        />
        <path
          d="M114.707 18.4H112.6L118.695 1.8H120.77L126.865 18.4H124.758L119.797 4.42617H119.668L114.707 18.4ZM115.485 11.9156H123.98V13.6988H115.485V11.9156Z"
          className="primary"
        />
        <path d="M131.461 1.8V18.4H129.451V1.8H131.461Z" className="primary" />
      </svg>
    </S.ToggleLogotypeRoot>
  );
};
